<template>
  <div class="pc-preview-container">
    <div
      v-if="method === 'phone' || method === 'email'"
      class="pc-preview-background"
    >
      <img
        v-if="image === 'hvac101'"
        src="@shared/assets/img/partner-detail/hvac-101-phone.png"
        class="pc-phone-img"
        alt="phone-img"
      />
      <img
        v-else
        src="@shared/assets/img/partner-detail/my-tech.png"
        class="pc-phone-img"
        alt="phone-img"
      />
      <div class="pc-absolute-overlay">
        <div class="pc-popup-background-container">
          <div v-if="logoPreview" class="pc-logo-container">
            <img :src="logoPreview" class="pc-logo-img" alt="logo" />
          </div>
          <div class="pc-schedule-preview-info-container">
            <div class="pc-preview-info-title mt-2">
              {{ serviceRequest ? "To schedule a service, please contact " : "For questions about your maintenance, please contact " }}<b>{{ companyName }}</b>
            </div>
            <div v-if="email" class="flex-row align-center mt-2">
              <div class="icon-bubble">
                <span class="icon-luc-Mail sac__font-14 f-white" />
              </div>
              <div class="pc-preview-info ml-2 text-overflow">
                {{ email }}
              </div>
            </div>
            <div v-if="phone" class="flex-row align-center mt-2">
              <div class="icon-bubble">
                <span class="icon-luc-Phone sac__font-14 f-white" />
              </div>
              <div class="pc-preview-info ml-2 text-overflow">
                {{ phone }}
              </div>
            </div>
            <div v-if="website" class="flex-row align-center mt-2">
              <div class="icon-bubble">
                <span class="icon-Globe-Wire sac__font-14 f-white" />
              </div>
              <div class="pc-preview-info ml-2 text-overflow">
                {{ website }}
              </div>
            </div>
            <div v-if="button" class="btn flex-row just-center align-center pt-2 pb-2 mt-3">
              <div class="sac__font-12 med f-white">
                Schedule Service
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img
      v-else
      src="@shared/assets/img/partner-detail/support-preview.png"
      class="pc-phone-img"
    />
    <div class="pc-preview-title">
      {{
        image === 'hvac101' ? 'HVAC 101' : method === 'phone' || method === 'email'
          ? 'Direct to Company'
          : 'Support Chat'
      }}
    </div>
    <div class="sac__font-12 n60 text-center">
      Member App
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceRequestPreview',
  props: {
    primaryColor: String,
    companyName: String,
    serviceRequest: Boolean,
    button: Boolean,
    phone: String,
    website: String,
    image: String,
    method: String,
    email: String,
    logoPreview: String,
  },
  computed: {
    backgroundStyles() {
      return {
        'background-color': this.primaryColor,
        display: 'flex',
        'justify-content': 'flex-end',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-preview-container {
  margin-left: 12px;
  margin-top: 15px;

  .pc-preview-background {
    position: relative;
    border-radius: 50px;
    height: 91%;
  }

  .pc-phone-img {
    height: 520px;
  }

  .pc-absolute-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    backdrop-filter: blur(1px);
  }

  .pc-popup-background-container {
    width: 77%;
    border-radius: 4px;
    border: 1px solid #C4C5CC;
    padding: 10px 12px;
    display: flex;
    background-color: #1E243B;
    justify-content: flex-end;
    flex-direction: column;
    .pc-preview-img {
      //background-color: white;

      width: 100%;
    }
  }

  .pc-schedule-preview-info-container {
    text-align: center;
    color: $WHITE;
  }
  .icon-bubble{
    background-color: #4980FF;
    padding: 3px 5px;
    border-radius: 50px;
  }
  .pc-preview-info-title {
    font-weight: 500;
    font-size: 0.75rem;
    color: $WHITE;
  }

  .pc-preview-info {
    font-size: 0.625rem;
    font-weight: 500;
  }

  .pc-logo-container {
    //position: absolute;
    //top: 75px;
    //left: 0;
    //right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .pc-logo-img {
      width: 75px;
      height: 75px;
      object-fit: contain;
    }
  }

  .pc-preview-title {
    margin-top: 14px;
    text-align: center;
  }

  .btn {
    border-radius: 6px;
    background-color: $BLUE_40;
  }
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
